<div class="dialog-container">
  <div class="dialog-header">
    <div class="header-content">
      <div class="title-section">
        <mat-icon class="header-icon">sports_soccer</mat-icon>
        <h2 mat-dialog-title>Players</h2>
      </div>
      <button mat-icon-button class="close-button" (click)="onClose()" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="account-info">
      <div class="info-item">
        <mat-icon>account_circle</mat-icon>
        <span>{{ data.account.name }}</span>
      </div>
      <div class="info-item">
        <mat-icon>paid</mat-icon>
        <span>{{ credits / 1000 | number }}K coins</span>
      </div>
      <button mat-icon-button (click)="loadPlayers()" [disabled]="loading" class="refresh-btn"
        matTooltip="Refresh players">
        <mat-icon>refresh</mat-icon>
      </button>
    </div>
  </div>

  <mat-dialog-content>
    @if (loading) {
    <div class="loading-state">
      <mat-progress-spinner diameter="40" mode="indeterminate"></mat-progress-spinner>
      <p>Loading players...</p>
    </div>
    } @else if (playerGroups.length === 0) {
    <div class="empty-state">
      <mat-icon class="empty-icon">inbox</mat-icon>
      <h3>No Players</h3>
      <p>No players found in tradepile or unassigned pile.</p>
    </div>
    } @else {
    <div class="players-list">
      @for (group of playerGroups; track group.key) {
      <!-- Multiple players - use expansion panel -->
      <mat-accordion class="player-accordion">
        <mat-expansion-panel class="player-card" [class]="getGroupColor(group)"
          [disabled]="group.trade_state === 'active' || group.trade_state === 'closed'">
          <mat-expansion-panel-header>
            <div class="player-header-expandable">
              <div class="player-info">
                <div class="player-title">
                  <mat-icon class="location-icon">{{ getLocationIcon(group.location) }}</mat-icon>
                  <span class="player-name">{{ group.player_name }}</span>
                  <span class="player-rating">{{ group.rating }}</span>
                  <span class="count-badge">×{{ group.count }}</span>
                </div>
                <div class="player-meta">
                  <span class="location">{{ getStatusName(group) }}</span>
                </div>
              </div>

              @if (group.buy_now_price != null || group.starting_bid != null) {
              <div class="trade-info">
                <div class="price-row">
                  @if (group.items[0].expires && group.items[0].expires > 0) {
                  <div class="expires">
                    <mat-icon>schedule</mat-icon>
                    {{ formatExpires(group.items[0].expires) }}
                  </div>
                  }
                  <span class="price-label">Start Bid:</span>
                  <span class="price-value">{{ group.starting_bid | number }}</span>
                </div>
                <div class="price-row">
                  <span class="price-label">Buy Now:</span>
                  <span class="price-value">{{ group.buy_now_price | number }}</span>
                </div>

              </div>
              }
            </div>
          </mat-expansion-panel-header>

          <div class="expansion-content">
            @if (group.trade_state === 'expired' || !group.trade_state) {
            <div class="list-player-form-expanded">
              <div class="form-header">List one of {{ group.count }} players</div>
              <div class="form-inputs">
                <mat-form-field appearance="outline" class="price-input" subscriptSizing="dynamic">
                  <mat-label>Buy Now Price</mat-label>
                  <input matInput type="number" [(ngModel)]="group.listBuyNowPrice"
                    [disabled]="group.listingInProgress ?? false">
                </mat-form-field>
                <mat-form-field appearance="outline" class="price-input" subscriptSizing="dynamic">
                  <mat-label>Starting Bid</mat-label>
                  <input matInput type="number" [(ngModel)]="group.listStartingBid"
                    [disabled]="group.listingInProgress ?? false">
                </mat-form-field>

                <span class="spacer"></span>
                <button mat-flat-button color="primary" (click)="listPlayer(group)"
                  [disabled]="group.listingInProgress">
                  @if (group.listingInProgress) {
                  <mat-spinner diameter="20"></mat-spinner>
                  } @else {
                  <ng-container>
                    List Player
                  </ng-container>
                  }
                </button>
              </div>
            </div>

            <mat-divider></mat-divider>

            <div class="list-player-form-expanded">
              <div class="form-header content-row">
                <span>
                  Quick sell one of {{ group.count }} players for {{ group.discard_value | number }} coins
                </span>

                <span class="spacer"></span>

                <button mat-flat-button color="primary" (click)="quickSellPlayer(group)"
                  [disabled]="group.quickSellingInProgress">
                  @if (group.quickSellingInProgress) {
                  <mat-spinner diameter="20"></mat-spinner>
                  } @else {
                  <ng-container>
                    Quick Sell Player
                  </ng-container>
                  }
                </button>
              </div>
            </div>
            }
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      }
    </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-raised-button (click)="onClose()">
      Close
    </button>
  </mat-dialog-actions>
</div>